import React from "react";

// Component tùy chỉnh cho nút arrow prev
const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <button
      className={`${className} slide-arrow prev-arrow`}
      style={{ ...style }}
      onClick={onClick}
    >
      <i className="bi bi-arrow-left"></i>
    </button>
  );
};

export default PrevArrow;
